// extracted by mini-css-extract-plugin
export default {"trustpilot":"trustpilot___HAz56","features":"features___MwYeH","feature":"feature___du0Q9","no_logo":"no_logo___peEQx"};